import * as http from 'utils/http';
import config from 'config';
import { shipperUsersIncreasingAlphabetical } from 'utils/sort';

export async function fetchShipper(shipperId) {
  const shipper = await http.get(`${config.BASE_URL}/api/shippers/${shipperId}/`);
  const users = await fetchShipperUsers(shipperId);
  return { ...shipper, users };
}

export async function fetchShipperUsers(shipperId) {
  const users = await http.get(`${config.BASE_URL}/api/users/?shipper=${shipperId}&page_size=0`);

  return users?.sort(shipperUsersIncreasingAlphabetical);
}

export async function fetchUser(userId) {
  return await http.get(`${config.BASE_URL}/api/users/${userId}/`);
}

export async function resendInvitationLink(url) {
  return await http.put(url);
}

export async function updateShipperUser(userId, data) {
  return await http.patch(`${config.BASE_URL}/api/users/${userId}/`, data);
}

export async function createShipperUser(shipperId, data) {
  return await http.post(`${config.API_URL}shippers/${shipperId}/users/`, data);
}

export async function updateShipper(shipperId, data) {
  return http.patch(`${config.API_URL}shippers/${shipperId}/`, data);
}
